import React from 'react'
import { Toast } from 'react-bootstrap'

interface AxiosErrorLike {
    response?: { status: number }
}

interface Props {
    error: AxiosErrorLike | null
    onDismiss: () => void
}

function ErrorToast({ error, onDismiss }: Props) {
    if (!error) return null

    const status = error.response ? error.response.status : null
    const message = status
        ? `Request failed with status ${status}.`
        : 'An unexpected error occurred.'

    return (
        <div style={{ position: 'fixed', bottom: '1.5rem', right: '1.5rem', zIndex: 9999 }}>
            <Toast onClose={onDismiss} show={true} delay={6000} autohide>
                <Toast.Header>
                    <strong className="mr-auto text-danger">Error</strong>
                </Toast.Header>
                <Toast.Body>{message}</Toast.Body>
            </Toast>
        </div>
    )
}

export default ErrorToast
